import { TableBody, TableCell } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useAttendance } from '../../../hooks/Features/useAttendance'
import { itemsPerPage } from '../../../shared/data'
import CustomHeading from '../../CustomHeading'
import CustomPagination from '../../CustomPagination'
import Layout from '../../Layout'
import Loader from '../../Loader'
import { NoDataFound } from '../../NoDataFound'
import CustomTable from '../../Table/CustomTable'
import CustomTableHeading from '../../Table/CustomTableHeading'
import CustomTableRow from '../../Table/CustomTableRow'
import styles from '../reports.module.css'
import { SortIcon, FilterIcon } from '../../CustomComponents/CustomFilterIcon'

export default function ProductiveTimeReport() {
  const { getProductiveTimeReport, attendance, loading } = useAttendance()
  const [page, setPage] = React.useState(1)
  const startDate = new Date()
  startDate.setDate(1)
  startDate.setHours(0, 0, 0)
  const [from, setFrom] = useState(startDate.toISOString())
  const [to, setTo] = useState(new Date().toISOString())
  const [filterParams, setFilterParams] = useState({})

  useEffect(() => {
    setPage(1)
    getProductiveTimeReport({ from, to, ...filterParams })
  }, [from, to, filterParams])

  const noOfPages = Math.ceil(attendance && attendance.length / itemsPerPage)
  const handleChange = (event, value) => {
    setPage(value)
  }

  const heading = [
    { label: 'Region', key: 'region' },
    { label: 'Zone', key: 'zone' },
    { label: 'State', key: 'state' },
    { label: 'District', key: 'district' },
    { label: 'City', key: 'city' },
    { label: 'TSM', key: 'tsm' },
    { label: 'KBC Name', key: 'kbc' },
    { label: 'Productive Hours', key: 'productive' },
  ]

  let tempAttendance = []
  attendance &&
    attendance.forEach((item) =>
      tempAttendance.push({
        region: item.region && item.region.name,
        zone: item.zone && item.zone.name,
        state: item.state && item.state.name,
        district: item.district && item.district.name,
        city: item.city && item.city.name,
        tsm: item.rank5Name,
        kbc: item.rank6Name,
        productive: item.productive,
      })
    )

  const headingOnClick = {
    'Productive Hours': () => {
      setFilterParams({ ...filterParams, productive: filterParams.productive === 1 ? -1 : 1 })
    },
  }

  return (
    <Layout
      heading="Productive Time Report"
      none
      selectedFrom={from}
      setSelectedFrom={setFrom}
      selectedTo={to}
      setSelectedTo={setTo}
      headers={heading}
      data={tempAttendance ? tempAttendance : []}
      tempHeaderData={[]}
      filename="productive_time_report"
    >
      <CustomTable padding className={styles.table}>
        <CustomTableHeading
          filterIcons={{
            'Productive Hours': <SortIcon onClick={headingOnClick['Productive Hours']} value={filterParams.productive} />,
          }}
          heading={['REGION', 'ZONE', 'STATE', 'DISTRICT', 'CITY', 'TSM', 'KBC Name', 'Productive Hours']}
        />
        <TableBody className={styles.tr}>
          {!loading &&
            attendance.length > 0 &&
            attendance.slice((page - 1) * itemsPerPage, page * itemsPerPage).map((item, index) => {
              return (
                <CustomTableRow>
                  <TableCell> {item.region ? item.region.name : '-----'} </TableCell>
                  <TableCell> {item.zone ? item.zone.name : '-----'} </TableCell>
                  <TableCell> {item.state ? item.state.name : '-----'} </TableCell>
                  <TableCell> {item.district ? item.district.name : '-----'} </TableCell>
                  <TableCell> {item.city ? item.city.name : '-----'} </TableCell>
                  <TableCell> {item.rank5Name ? item.rank5Name : '-----'} </TableCell>
                  <TableCell> {item.rank6Name ? item.rank6Name : ''} </TableCell>
                  <TableCell> {item.productive} </TableCell>
                </CustomTableRow>
              )
            })}
        </TableBody>
      </CustomTable>
      {!loading && attendance.length > 0 && (
        <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />
      )}
      {loading && <Loader />}
      {!loading && attendance.length === 0 && <NoDataFound />}
    </Layout>
  )
}
